import { addSeconds } from "date-fns"
import { BookingBookingPayload, BookingEmployeeBooking } from "../../../services/booking/types"
import { formatTime, formatLocalDateYmd } from "../../../utils/date-utils"
import { combineDateAndTime, getPeriodFromBooking } from "../utils/utils"
import { BookingPeriods } from "../Popover/enums"
import { BOOKING_LENGTH_OPTION_MAP } from "../consts"

export function BookingWindow({ booking, selectedDate }: {booking: BookingBookingPayload | BookingEmployeeBooking, selectedDate: Date}) {
  const fullDateFrom = combineDateAndTime(booking.fromDate, booking.fromTime)
  const fullDateTo = combineDateAndTime(booking.toDate, booking.toTime)
  const bookingPeriod = getPeriodFromBooking(booking)
  if (bookingPeriod !== BookingPeriods.CUSTOM_TIME_SLOT) {
    return <span>{BOOKING_LENGTH_OPTION_MAP[bookingPeriod].text}</span>
  }

  const fromTime = booking.fromTime.slice(0, 5)
  const toTime = formatTime(addSeconds(combineDateAndTime(booking.toDate, booking.toTime), 1), true)

  const isOvernightBooking = formatLocalDateYmd(fullDateTo) > formatLocalDateYmd(selectedDate)
  const isPreviousDayBooking = formatLocalDateYmd(fullDateFrom) < formatLocalDateYmd(selectedDate)
  return (
    <span>
      {fromTime}
      {isPreviousDayBooking && <span style={{ verticalAlign: "top", fontSize: '9px' }}>-1</span>}
      {' - '}
      {toTime}
      {isOvernightBooking && <span style={{ verticalAlign: "top", fontSize: '9px' }}>+1</span>}
    </span>
  )
}